/* Temp fix for buggy carousel on page load (some of the time) */
document.addEventListener("DOMContentLoaded", function() {
  var rolexImageBanner = document.querySelector('.rolex-carousel-reload');
  if (rolexImageBanner) {
    if (!rolexImageBanner.classList.contains('slick-initialized')) {
      location.reload();
    }
  }
})